import { BaseEmptyPrefixControlBehaviour } from './BaseControlBehaviour';
/**
 * Changables - элемент с аттрибутом changable и input или select
 * будет обрабатываться как элемент с начальными данными лежащими в data-initial-value
 * каждый раз при изменении, данный элемент будет помечаться модификатором m-changed, если данные отличаются от начальных
 * В аттрибуте можно указать список ID buttons которые будут дизейблится при изменении
 */
export class ChangablesBehaviour extends BaseEmptyPrefixControlBehaviour {
    constructor() {
        super('changable');
    }

    protected installBehaviour(element: HTMLElement): void {
        const initialValue = this.getValue(element);
        $(element).attr('data-initial-value', initialValue);
        $(element).change((e) => this.handleChangableChanged(e));
    }

    private handleChangableChanged(evt) {
        const currentElement = evt.currentTarget;
        const config = Utils.getObjectByAttributes(
            this.tag,
            currentElement,
            null,
            { modifier: 'm-changed' }
        );
        const tagValue = this.getBehaviorValue(currentElement);

        const initialValue = $(currentElement).attr('data-initial-value');
        const currentValue = this.getValue(currentElement);
        if (currentValue == initialValue) {
            $(currentElement).removeClass(config.modifier);
            if (tagValue) {
                $(tagValue).each((index, elem) => {
                    $(elem).removeClass('m-disabled');
                });
            }
        } else {
            $(currentElement).addClass(config.modifier);
            if (tagValue) {
                $(tagValue).each((index, elem) => {
                    $(elem).addClass('m-disabled');
                });
            }
        }
    }

    private getValue(element: HTMLElement): any {
        const changableFullType = Utils.getElementFullType(element);
        if (changableFullType == 'select') {
            return $(element).find(':selected').val();
        }
        return $(element).val();
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.ChangablesBehaviour = ChangablesBehaviour;